import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gen-pro-list-grid',
  templateUrl: './gen-pro-list-grid.component.html',
  styleUrls: ['./gen-pro-list-grid.component.css']
})
export class GenProListGridComponent implements OnInit {

  title="Generate Promotion List";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Promotions/general-promotion-list/gen-pro-list-grid/gen-pro-list-grid.component.ts